import React from 'react'

export const PostsSizeIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		width='76'
		height='76'
		viewBox='0 0 76 76'>
		<defs>
			<linearGradient
				id='linear-gradient'
				x2='1.037'
				y2='1.356'
				gradientUnits='objectBoundingBox'>
				<stop offset='0' stopColor='#fff9fb' />
				<stop offset='1' stopColor='#ff80a2' />
			</linearGradient>
			<linearGradient
				id='linear-gradient-2'
				x1='0.5'
				x2='0.5'
				y2='1'
				gradientUnits='objectBoundingBox'>
				<stop offset='0' stopColor='#ffa7be' />
				<stop offset='1' stopColor='#ff80a2' />
			</linearGradient>
		</defs>
		<g id='Group_4747' data-name='Group 4747' transform='translate(-706 -411)'>
			<g id='Group_4756' data-name='Group 4756' transform='translate(706 411)'>
				<g id='Group_4701' data-name='Group 4701'>
					<rect
						id='Rectangle_36'
						data-name='Rectangle 36'
						width='76'
						height='76'
						rx='7'
						fill='url(#linear-gradient)'
					/>
				</g>
			</g>
			<g transform='translate(717.31 473.079)'>
				<g>
					<circle
						id='Ellipse_15'
						data-name='Ellipse 15'
						cx='2.089'
						cy='2.089'
						r='2.089'
						fill='#ff3067'
					/>
				</g>
				<g data-name='Group 4751' transform='translate(7.383)'>
					<circle
						id='Ellipse_16'
						data-name='Ellipse 16'
						cx='2.089'
						cy='2.089'
						r='2.089'
						fill='#ff3067'
					/>
				</g>
				<g transform='translate(14.765)'>
					<circle
						id='Ellipse_17'
						data-name='Ellipse 17'
						cx='2.089'
						cy='2.089'
						r='2.089'
						fill='#ff3067'
					/>
				</g>
			</g>
			<g
				id='Group_4755'
				data-name='Group 4755'
				transform='translate(717.112 420.77)'>
				<g
					id='Group_4750-2'
					data-name='Group 4750'
					transform='translate(25.305 0)'>
					<path
						id='Path_3556'
						data-name='Path 3556'
						d='M239.559,42.808H233.1a1.492,1.492,0,0,1,0-2.983h6.462a1.492,1.492,0,0,1,0,2.983Z'
						transform='translate(-231.605 -39.825)'
						fill='#ff3067'
					/>
				</g>
				<g id='Group_4751-2' data-name='Group 4751' transform='translate(0 0)'>
					<path
						id='Path_3557'
						data-name='Path 3557'
						d='M123.55,42.808H105.9a1.492,1.492,0,1,1,0-2.983h17.65a1.492,1.492,0,1,1,0,2.983Z'
						transform='translate(-104.409 -39.825)'
						fill='#ff3067'
					/>
				</g>
			</g>
			<g
				id='Group_4754'
				data-name='Group 4754'
				transform='translate(717.219 429.454)'>
				<g id='Group_4748' data-name='Group 4748' transform='translate(0 0)'>
					<path
						id='Path_3555'
						data-name='Path 3555'
						d='M157.309,125.943h-2.042L123.6,123.627l-18.2-14V88.277a1.865,1.865,0,0,1,1.961-1.75h49.944a1.865,1.865,0,0,1,1.961,1.75v35.915A1.865,1.865,0,0,1,157.309,125.943Z'
						transform='translate(-105.404 -86.527)'
						fill='url(#linear-gradient-2)'
					/>
				</g>
				<g
					id='Group_4752-2'
					data-name='Group 4752'
					transform='translate(0 15.256)'>
					<path
						id='Path_3558'
						data-name='Path 3558'
						d='M107.379,197.849h48.316l-18.907-16.732a2.163,2.163,0,0,0-2.8,0l-4.148,3.67a1.081,1.081,0,0,1-1.4,0L116.483,174.2a2.163,2.163,0,0,0-2.8,0l-8.285,7.332V196.1A1.874,1.874,0,0,0,107.379,197.849Z'
						transform='translate(-105.402 -173.689)'
						fill='#ff3067'
					/>
				</g>
				<g
					id='Group_4753'
					data-name='Group 4753'
					transform='translate(36.267 9.11)'>
					<circle
						id='Ellipse_18'
						data-name='Ellipse 18'
						cx='3.335'
						cy='3.335'
						r='3.335'
						fill='#ff3067'
					/>
				</g>
			</g>
		</g>
	</svg>
)

export const StorySizeIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		width='63'
		height='110'
		viewBox='0 0 63 110'>
		<defs>
			<linearGradient
				id='linear-gradient'
				x2='1.037'
				y2='1.356'
				gradientUnits='objectBoundingBox'>
				<stop offset='0' stopColor='#ff3067' />
				<stop offset='1' stopColor='#a5119f' />
			</linearGradient>
			<linearGradient
				id='linear-gradient-2'
				x1='0.5'
				x2='0.5'
				y2='1'
				gradientUnits='objectBoundingBox'>
				<stop offset='0' stopColor='#fffcfd' />
				<stop offset='1' stopColor='#ff80a2' />
			</linearGradient>
		</defs>
		<g
			id='Group_4758'
			data-name='Group 4758'
			transform='translate(-705.511 -411.033)'>
			<g id='Group_4756' data-name='Group 4756' transform='translate(706 411)'>
				<g id='Group_4701' data-name='Group 4701'>
					<rect
						id='Rectangle_36'
						data-name='Rectangle 36'
						width='63'
						height='110'
						rx='7'
						transform='translate(-0.489 0.033)'
						fill='url(#linear-gradient)'
					/>
				</g>
			</g>
			<g
				id='Group_4749'
				data-name='Group 4749'
				transform='translate(728.511 506.228)'>
				<g id='Group_4750' data-name='Group 4750'>
					<circle
						id='Ellipse_15'
						data-name='Ellipse 15'
						cx='1.825'
						cy='1.825'
						r='1.825'
						fill='#fff9fb'
					/>
				</g>
				<g id='Group_4751' data-name='Group 4751' transform='translate(6.449)'>
					<circle
						id='Ellipse_16'
						data-name='Ellipse 16'
						cx='1.825'
						cy='1.825'
						r='1.825'
						fill='#fff9fb'
					/>
				</g>
				<g id='Group_4752' data-name='Group 4752' transform='translate(12.898)'>
					<circle
						id='Ellipse_17'
						data-name='Ellipse 17'
						cx='1.825'
						cy='1.825'
						r='1.825'
						fill='#fff9fb'
					/>
				</g>
			</g>
			<g
				id='Group_4755'
				data-name='Group 4755'
				transform='translate(721.511 419.534)'>
				<g
					id='Group_4750-2'
					data-name='Group 4750'
					transform='translate(22.105 0)'>
					<path
						id='Path_3556'
						data-name='Path 3556'
						d='M238.553,42.431h-5.645a1.3,1.3,0,0,1,0-2.606h5.645a1.3,1.3,0,0,1,0,2.606Z'
						transform='translate(-231.605 -39.825)'
						fill='#fff9fb'
					/>
				</g>
				<g id='Group_4751-2' data-name='Group 4751' transform='translate(0 0)'>
					<path
						id='Path_3557'
						data-name='Path 3557'
						d='M121.13,42.431H105.712a1.3,1.3,0,1,1,0-2.606H121.13a1.3,1.3,0,1,1,0,2.606Z'
						transform='translate(-104.409 -39.825)'
						fill='#fff9fb'
					/>
				</g>
			</g>
			<g id='Group_4762' data-name='Group 4762' transform='translate(0 5)'>
				<g
					id='Group_4759'
					data-name='Group 4759'
					transform='translate(721.511 475.535)'>
					<g
						id='Group_4750-3'
						data-name='Group 4750'
						transform='translate(22.105 0)'>
						<path
							id='Path_3556-2'
							data-name='Path 3556'
							d='M238.553,42.431h-5.645a1.3,1.3,0,0,1,0-2.606h5.645a1.3,1.3,0,0,1,0,2.606Z'
							transform='translate(-231.605 -39.825)'
							fill='#fff9fb'
						/>
					</g>
					<g
						id='Group_4751-3'
						data-name='Group 4751'
						transform='translate(0 0)'>
						<path
							id='Path_3557-2'
							data-name='Path 3557'
							d='M121.13,42.431H105.712a1.3,1.3,0,1,1,0-2.606H121.13a1.3,1.3,0,1,1,0,2.606Z'
							transform='translate(-104.409 -39.825)'
							fill='#fff9fb'
						/>
					</g>
				</g>
				<g
					id='Group_4760'
					data-name='Group 4760'
					transform='translate(721.511 482.535)'>
					<g
						id='Group_4750-4'
						data-name='Group 4750'
						transform='translate(22.105 0)'>
						<path
							id='Path_3556-3'
							data-name='Path 3556'
							d='M238.553,42.431h-5.645a1.3,1.3,0,0,1,0-2.606h5.645a1.3,1.3,0,0,1,0,2.606Z'
							transform='translate(-231.605 -39.825)'
							fill='#fff9fb'
						/>
					</g>
					<g
						id='Group_4751-4'
						data-name='Group 4751'
						transform='translate(0 0)'>
						<path
							id='Path_3557-3'
							data-name='Path 3557'
							d='M121.13,42.431H105.712a1.3,1.3,0,1,1,0-2.606H121.13a1.3,1.3,0,1,1,0,2.606Z'
							transform='translate(-104.409 -39.825)'
							fill='#fff9fb'
						/>
					</g>
				</g>
				<g
					id='Group_4761'
					data-name='Group 4761'
					transform='translate(721.511 489.535)'>
					<g
						id='Group_4750-5'
						data-name='Group 4750'
						transform='translate(22.105 0)'>
						<path
							id='Path_3556-4'
							data-name='Path 3556'
							d='M238.553,42.431h-5.645a1.3,1.3,0,0,1,0-2.606h5.645a1.3,1.3,0,0,1,0,2.606Z'
							transform='translate(-231.605 -39.825)'
							fill='#fff9fb'
						/>
					</g>
					<g
						id='Group_4751-5'
						data-name='Group 4751'
						transform='translate(0 0)'>
						<path
							id='Path_3557-4'
							data-name='Path 3557'
							d='M121.13,42.431H105.712a1.3,1.3,0,1,1,0-2.606H121.13a1.3,1.3,0,1,1,0,2.606Z'
							transform='translate(-104.409 -39.825)'
							fill='#fff9fb'
						/>
					</g>
				</g>
			</g>
			<g
				id='Group_4754'
				data-name='Group 4754'
				transform='translate(713.511 427.121)'>
				<g id='Group_4748' data-name='Group 4748' transform='translate(0 0)'>
					<path
						id='Path_3555'
						data-name='Path 3555'
						d='M150.745,129.338h-1.784L121.3,126.823l-15.9-6.206V88.428a1.814,1.814,0,0,1,1.713-1.9h43.628a1.814,1.814,0,0,1,1.713,1.9v39.009A1.814,1.814,0,0,1,150.745,129.338Z'
						transform='translate(-105.404 -86.527)'
						fill='url(#linear-gradient-2)'
					/>
				</g>
				<g
					id='Group_4752-2'
					data-name='Group 4752'
					transform='translate(0 21.706)'>
					<path
						id='Path_3558'
						data-name='Path 3558'
						d='M107.129,194.794h42.206l-16.516-14.616a1.89,1.89,0,0,0-2.442,0l-3.623,3.206a.945.945,0,0,1-1.221,0l-10.45-9.248a1.89,1.89,0,0,0-2.442,0l-7.238,6.4v12.724A1.637,1.637,0,0,0,107.129,194.794Z'
						transform='translate(-105.402 -173.689)'
						fill='#fc2f69'
					/>
				</g>
				<g
					id='Group_4753'
					data-name='Group 4753'
					transform='translate(31.68 10.289)'>
					<circle
						id='Ellipse_18'
						data-name='Ellipse 18'
						cx='2.913'
						cy='2.913'
						r='2.913'
						fill='#fc2f69'
					/>
				</g>
			</g>
		</g>
	</svg>
)

export const ExampleEyeIcon: React.FC = () => (
	<svg
		id='Group_4721'
		data-name='Group 4721'
		xmlns='http://www.w3.org/2000/svg'
		width='50.63'
		height='45.49'
		viewBox='0 0 50.627 45.488'>
		<g id='Group_4715' data-name='Group 4715' transform='translate(13 14)'>
			<g id='Group_4714' data-name='Group 4714'>
				<g id='Group_4713' data-name='Group 4713'>
					<path
						id='Path_3533'
						data-name='Path 3533'
						d='M140.4,271.151a3.436,3.436,0,1,0,3.436,3.436A3.439,3.439,0,0,0,140.4,271.151Z'
						transform='translate(-127.801 -265.996)'
						fill='#ff3067'
					/>
					<path
						id='Path_3534'
						data-name='Path 3534'
						d='M128.214,259.142a13.546,13.546,0,0,0-12.6,8.59,13.535,13.535,0,0,0,25.2,0A13.54,13.54,0,0,0,128.214,259.142Zm0,14.318a5.727,5.727,0,1,1,5.728-5.727A5.729,5.729,0,0,1,128.214,273.46Z'
						transform='translate(-115.615 -259.142)'
						fill='#ff3067'
					/>
				</g>
			</g>
		</g>
		<g id='Group_4716' data-name='Group 4716'>
			<g id='Group_4718' data-name='Group 4718'>
				<path
					id='Path_3535'
					data-name='Path 3535'
					d='M176.755,236.455h1.726a6.173,6.173,0,0,1,6.172,6.172v1.134a1.952,1.952,0,0,0,1.952,1.952h0a1.952,1.952,0,0,0,1.952-1.952v-1.134a10.076,10.076,0,0,0-10.076-10.076h-1.726A1.952,1.952,0,0,0,174.8,234.5h0A1.952,1.952,0,0,0,176.755,236.455Z'
					transform='translate(-137.93 -232.551)'
					fill='#7a719b'
				/>
				<path
					id='Path_3536'
					data-name='Path 3536'
					d='M90.855,243.762v-1.134a6.173,6.173,0,0,1,6.173-6.173h1.725a1.952,1.952,0,0,0,1.952-1.952h0a1.952,1.952,0,0,0-1.952-1.952H97.027a10.076,10.076,0,0,0-10.076,10.076v1.134a1.952,1.952,0,0,0,1.952,1.952h0A1.952,1.952,0,0,0,90.855,243.762Z'
					transform='translate(-86.951 -232.551)'
					fill='#7a719b'
				/>
				<path
					id='Path_3537'
					data-name='Path 3537'
					d='M184.653,300.742v1.134a6.173,6.173,0,0,1-6.173,6.173h-1.726A1.952,1.952,0,0,0,174.8,310h0a1.952,1.952,0,0,0,1.952,1.952h1.726a10.076,10.076,0,0,0,10.076-10.076v-1.134a1.952,1.952,0,0,0-1.952-1.952h0A1.952,1.952,0,0,0,184.653,300.742Z'
					transform='translate(-137.93 -266.465)'
					fill='#7a719b'
				/>
				<path
					id='Path_3538'
					data-name='Path 3538'
					d='M98.753,308.049H97.027a6.173,6.173,0,0,1-6.172-6.172v-1.134A1.952,1.952,0,0,0,88.9,298.79h0a1.952,1.952,0,0,0-1.952,1.952v1.134a10.077,10.077,0,0,0,10.077,10.077h1.725A1.952,1.952,0,0,0,100.705,310h0A1.952,1.952,0,0,0,98.753,308.049Z'
					transform='translate(-86.951 -266.465)'
					fill='#7a719b'
				/>
			</g>
		</g>
	</svg>
)
